export const generateShortId = (value?: string | number) =>
  `${value ? `${value}-` : ""}${Math.random()
    .toString(36)
    .substring(2, 9)}-${Date.now()}`;
